import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { APIService } from '../../../../../api/api.service';
import { NotifierService } from '../../../../../_services/notifier.service';
import { regions } from './../../../../../dash/dash.component';
import { environment } from 'src/environments/environment';

declare let $: any;
declare let flatpickr: any;

@Component({
  selector: 'mrr-enables3-update',
  templateUrl: './updates3.component.html',
  styleUrls: ['./updates3.component.css'],
})
export class MrrUpdateS3Component implements OnInit, OnDestroy {
  additionalContacts: string[] = [''];
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  regions: any = regions;
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  accountId: any;
  regionId: any;
  dateRange: any;
  selectAll: boolean = false;
  RITypes: any = [];
  currentMessage: any;
  @Output() hideModel = new EventEmitter<any>();
  @Input() ri: any;
  @Input('action') action: any;
  @Input() childs: any[] = [];
  instanceTypes: any;
  platformTypes: any;
  linkedAccounts: any = {};
  selectedAccounts: any;
  accounts: any;
  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.ri = { ...this.ri };
    $('#regionsList').selectpicker();
    setTimeout(() => {
      $('#regions_reg').selectpicker();
      $('#platformsList').selectpicker();
    }, 500);
    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');
    this.linkedAccounts = JSON.parse(
      localStorage.getItem('accountIdData') || '{}',
    );
    if (Array.isArray(this.linkedAccounts.list)) {
      this.accounts = this.linkedAccounts.list.map(
        (accountObj: any) => accountObj.account,
      );
    } else {
      console.error(
        'linkedAccounts does not have a valid list key or it is not an array.',
      );
    }
    setTimeout(() => {
      $('#linkedAccounts').selectpicker('refresh');
    }, 100);

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.load();
      } else if (d.key == 'accountIdData') {
        this.linkedAccounts = d.value;
        this.load();
      }
    });
    flatpickr('#dataRangePicker', {
      dateFormat: 'Y-m-d',
      mode: 'range',
      showMonths: 2,
      defaultDate: this.dateRange ? this.dateRange.split(' to ') : null,
      onChange: (selectedDates: any, dateStr: any, instance: any) => {
        if (!dateStr.includes('to')) return;
        this.dateRange = dateStr;
      },
    });

    if (this.action == 'update') {
      if (this.ri.discountType == 'value') {
        this.disc = this.ri.discount;
      } else {
        this.disc = this.ri.discountPercentage;
      }
      this.dateRange = this.ri.startDate + ' to ' + this.ri.endDate;
      if (this.ri.usageType == 'all') {
        this.selectAll = true;
      }
    }
  }

  disc: any;
  load() {
    this.fetchInstanceTypes();
    if (this.action == 'update' && this.ri.usageType !== 'all') {
      this.fetchPlatformsTypes();
    }
    // this.fetchRITypes();
    // this.fetchPlatformsTypes();
  }
  validateNumericInput(event: KeyboardEvent): void {
    // Allow only numeric characters (0-9) and control keys (backspace, delete, arrows)
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Tab',
    ];
    if (allowedKeys.includes(event.key)) {
      return; // Allow control keys
    }

    // Block any non-numeric keys
    const isNumeric = /^[0-9]$/.test(event.key);
    if (!isNumeric) {
      event.preventDefault();
    }
  }

  selectAllRegions(event: any) {
    if (event.target.checked) {
      this.ri.regionn = this.regions_reg.map((region: any) => region);
    } else {
      this.ri.regionn = [];
    }

    this.fetchPlatformsTypes();

    setTimeout(() => {
      $('#regions_reg').selectpicker('refresh');
    }, 10);
  }

  selectAllchilds(event: any) {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Select all accounts
      this.ri.linkedAccounts = this.linkedAccounts['list'].map(
        (account: any) => account.accountId,
      );
    } else {
      // Deselect all accounts
      this.ri.linkedAccounts = [];
    }
    setTimeout(() => {
      $('#linkedAccounts').selectpicker('refresh');
    }, 10);
  }

  selectFiltertedRegions(event: Event) {
    let input = document
      .querySelector('#regions_reg')
      .parentElement.querySelector('.dropdown-menu')
      .querySelector('input');

    if (input.value.trim() == '') {
      return;
    }

    this.ri.regionn = this.regions_reg.filter(
      (region: any) =>
        region.toLowerCase().indexOf(input.value.toLowerCase()) > -1,
    );

    this.fetchPlatformsTypes();

    setTimeout(() => {
      $('#regions_reg').selectpicker('refresh');
    }, 10);
  }

  selectAllUsageTypes(event: any) {
    if (event.target.checked) {
      this.ri.usageType = this.usageType.map((platform: any) => platform);
    } else {
      this.ri.usageType = [];
    }
    setTimeout(() => {
      $('#platformsList').selectpicker('refresh');
    }, 10);
  }

  selectFiltertedUsageTypes(event: Event) {
    let input = document
      .querySelector('#platformsList')
      .parentElement.querySelector('.dropdown-menu')
      .querySelector('input');

    if (input.value.trim() == '') {
      return;
    }

    this.ri.usageType = this.usageType.filter(
      (platform: any) =>
        platform.toLowerCase().indexOf(input.value.toLowerCase()) > -1,
    );

    setTimeout(() => {
      $('#platformsList').selectpicker('refresh');
    }, 10);
  }

  onSelectAllChange() {
    this.ri.usageType = this.selectAll ? 'all' : '';
  }
  async fetchRICost() {
    if (this.ri.regionn.length > 1 || this.ri.usageType.length > 1) {
      return;
    } else if (this.ri.usageType.length !== 0) {
      let region: string = $('#regionn').val();
      let usageType: string = $('#usageType').val();
      this.notifier.loading(true);
      let data = {
        action: 'getUsageTypeDetails',
        usageType: this.ri.usageType[0].split('_')[0],
        region: this.ri.regionn[0],
      };
      let header = {
        Authorization: localStorage.getItem('t'),
      };

      let apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/s3-enable`;

      let result = await this.apiService.postDataPromis(apiURL, data, header);
      if (result.status == '1' || result.s == '1') {
        let response;
        response = result.data[0];
        this.ri = {
          ...this.ri,
          description: response.description,
          discount: response.discount,
          // regionn: response.regionn,
          // usageType: response.usageType,
          unit: response.unit,
          ppu: response.ppu,
        };
      } else {
        this.notifier.alert('Info', '', result.msg, 'info', 5000);
      }

      this.notifier.loading(false);
    }
  }
  regions_reg: any;
  async fetchInstanceTypes() {
    this.notifier.loading(true);
    let data = { action: 'fetchUniqueRegions' };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/s3-enable`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.regions_reg = result.regions;
      console.log(this.regions_reg);
      setTimeout(() => {
        $('#regions_reg').selectpicker('refresh');
      }, 100);
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  usageType: any;
  async fetchPlatformsTypes() {
    this.notifier.loading(true);
    let data = {
      action: 'getRegionWiseUsageTypes',
      regionList: this.ri.regionn,
      childIds: this.ri.linkedAccounts,
      accountId: this.accountId,
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/s3-enable`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.usageType = result.usageType;
      setTimeout(() => {
        $('#platformsList').selectpicker('refresh');
      }, 100);
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  isFormValid() {
    return (
      !!this.ri.regionn &&
      !!this.ri.usageType &&
      !!this.ri.discountPercentage &&
      !!this.ri.unit &&
      !!this.ri.ppu
    );
  }

  showInvalidFieldNotification() {
    if (this.ri.regionn.length === 0) {
      this.notifier.alert('Error', '', 'Region is required', 'error', 5000);
      return;
    }
    if (this.ri.usageType.length === 0) {
      this.notifier.alert('Error', '', 'Usage Type is required', 'error', 5000);
      return;
    }
    if (!this.ri.discountPercentage) {
      this.notifier.alert('Error', '', 'Discount is required', 'error', 5000);
      return;
    }
  }

  getDisplayName(type: string): string {
    return type.split('_')[0];
  }

  trackByFn() {
    return true;
  }
  showInvalidFieldNotificationall() {
    if (!this.ri.usageType) {
      this.notifier.alert('Error', '', 'Usage Type is required', 'error', 5000);
      return;
    }
    if (!this.ri.discountPercentage) {
      this.notifier.alert('Error', '', 'Discount is required', 'error', 5000);
      return;
    }
    if (this.dateRange == '' || this.dateRange == undefined) {
      this.notifier.alert('Info', '', 'Please select date range', 'info', 500);
      return;
    }
  }
  getFormData(): { isValid: boolean; data: any; errors: string[] } {
    const errors: string[] = [];

    // ─── Validations ─────────────────────────────────────
    if (!this.ri.regionn || this.ri.regionn.length === 0) {
      errors.push('Region is required');
    }
    if (!this.ri.usageType || this.ri.usageType.length === 0) {
      errors.push('Usage Type is required');
    }

    const rawDiscount = this.disc ?? this.ri.discountPercentage;
    const cleanedDiscount = rawDiscount?.toString().replace(/%/g, '').trim();

    if (!cleanedDiscount && cleanedDiscount !== '0') {
      errors.push('Discount is required');
    }
    if (!this.dateRange) {
      errors.push('Date range is required');
    }

    if (errors.length > 0) {
      return { isValid: false, data: null, errors };
    }

    // ─── Date Handling ───────────────────────────────────
    const [startDate, endDate] = this.dateRange
      .split(' to ')
      .map((d: string) => d.trim());

    // ─── Normalize Arrays ────────────────────────────────
    const regions: string[] = Array.isArray(this.ri.regionn)
      ? this.ri.regionn
      : [this.ri.regionn];

    const usageTypes: string[] = Array.isArray(this.ri.usageType)
      ? this.ri.usageType
      : [this.ri.usageType];

    // ─── addMultiple: multiple regions OR multiple usageTypes ────────────
    const isMultiple = regions.length > 1 || usageTypes.length > 1;

    if (isMultiple) {
      return {
        isValid: true,
        data: {
          isMultiple: true, // ← signals parent to call addMultipleS3()
          childIds: this.childs,
          regionList: regions,
          usageTypelist: usageTypes, // already carry region suffix e.g. "EUW3-Requests-Tier2_eu-west-3"
          startDate,
          endDate,
          discountType: this.ri.discountType || 'percentage',
          discount: cleanedDiscount,
          ppu: this.ri.ppu || '',
        },
        errors: [],
      };
    }

    // ─── add (single region + single usageType) ──────────
    return {
      isValid: true,
      data: {
        isMultiple: false,
        childIds: this.childs,
        data: [
          {
            regionn: regions[0],
            description: this.ri.description || '',
            ppu: this.ri.ppu || '',
            discountType: this.ri.discountType || 'percentage',
            unit: this.ri.unit || '',
            usageType: usageTypes[0],
            discount: cleanedDiscount,
            startDate,
            endDate,
            uuid: this.ri.uuid || '',
          },
        ],
      },
      errors: [],
    };
  }

  ngOnDestroy(): void {
    if (this.currentMessage) {
      this.currentMessage.unsubscribe();
    }
  }
}